import { render, staticRenderFns } from "./MiddleBanner.vue?vue&type=template&id=d380fb4c&scoped=true"
import script from "./MiddleBanner.vue?vue&type=script&lang=js"
export * from "./MiddleBanner.vue?vue&type=script&lang=js"
import style0 from "./MiddleBanner.vue?vue&type=style&index=0&id=d380fb4c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d380fb4c",
  null
  
)

export default component.exports